import React from 'react';
import { FormField, FormLabel, Switch } from '@kiiwi/ui';
import { useTranslation } from '@/src/i18n';

export const LIMITATION_ALL_PATIENTS = 'ALL'; // All practitioners
const LIMITATION_KNOWN_PATIENTS = 'ALLOW'; // Practitioners who accept ONLY known patients

type Props = {
  filters: Record<string, any>;
  selectValue: (filter: Record<string, any>) => void;
};
const TLCPatientLimitationSwitch = ({ selectValue, filters }: Props) => {
  const { t } = useTranslation();
  const updatePatientLimitation = (checked: boolean) => {
    selectValue({
      newPatientFilter: checked ? LIMITATION_KNOWN_PATIENTS : undefined,
    });
  };
  return (
    <FormField className="flex flex-row items-center">
      <Switch
        checked={filters?.newPatientFilter === LIMITATION_KNOWN_PATIENTS}
        onCheckedChange={updatePatientLimitation}
      />
      <FormLabel className="text-base sm:text-sm">
        {t('open-for-new-patients')}
      </FormLabel>
    </FormField>
  );
};

export default TLCPatientLimitationSwitch;
